import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { IReducers } from '../../store/reducers';
import { InfoTipsComponent } from '../info-tips/info-tips.component';
import { openDialog, openSnackbar } from '../../store/actions/page.action';
import { DialogService } from '../../shared/ui/dialog/dialog.service';
import { ButtonColor, ButtonSize } from '../../store/models/button.model';
import { DialogComponent } from '../../shared/ui/dialog/dialog.component';
import { IWizardStep } from '../wizard/wizard.component';
import {
  ContactStatusSelectionStepComponent,
} from '../wizard/components/contact-status-selection-step/contact-status-selection-step.component';
import {
  ContactContactSelectionStepComponent,
} from '../wizard/components/contact-contact-selection-step/contact-contact-selection-step.component';
import {
  ContentCodeSelectorStepComponent,
} from '../wizard/components/content-code-selector-step/content-code-selector-step.component';
import {
  ContactCreateMessageStepComponent,
} from '../wizard/components/contact-create-message-step/contact-create-message-step.component';
import { ContactApproveStepComponent } from '../wizard/components/contact-approve-step/contact-approve-step.component';
import { MessageService } from '../../store/services/message.service';
import { IUserSessionData } from '../../store/models/user.model';
import {
  WaitForOneTimeMessageComponent,
} from '../wizard/components/wait-for-one-time-message/wait-for-one-time-message.component';

@Component({
  selector: 'app-one-time-message',
  templateUrl: './one-time-message.component.html',
  styleUrls: ['./one-time-message.component.scss'],
})
export class OneTimeMessageComponent implements OnInit {
  groupIds: number[];

  dialogRef: DialogComponent;

  wizardSteps: IWizardStep[];

  userSession: IUserSessionData;

  constructor(
    private readonly store$: Store<IReducers>,
    private readonly dialogService: DialogService,
    private readonly messagesService: MessageService,
  ) {
  }

  ngOnInit() {
    this.wizardSteps = [
      {
        title: 'Select contact groups',
        component: 'test 2',
        id: 'select-contact-group',
      },
      {
        title: 'Select status',
        component: ContactStatusSelectionStepComponent,
        id: ContactStatusSelectionStepComponent.STEP_NAME,
      },
      {
        title: 'Select contacts',
        component: ContactContactSelectionStepComponent,
        componentData: {
          groupIds: this.groupIds,
        },
        id: ContactContactSelectionStepComponent.STEP_NAME,
      },
      {
        title: 'Select content code',
        component: ContentCodeSelectorStepComponent,
        canSkip: true,
        id: ContentCodeSelectorStepComponent.STEP_NAME,
      },
      {
        title: 'Create test message',
        component: ContactCreateMessageStepComponent,
        id: ContactCreateMessageStepComponent.STEP_NAME,
        componentData: {
          userSession: this.userSession,
        },
      },
      {
        title: 'Approve and email contacts',
        component: ContactApproveStepComponent,
        id: ContactApproveStepComponent.STEP_NAME,
      },
      {
        title: 'Wait for One-Time Message to be send',
        component: WaitForOneTimeMessageComponent,
        id: WaitForOneTimeMessageComponent.STEP_NAME,
      },
    ];
    this.store$.dispatch(
      openDialog({
        dialogData: {
          content: InfoTipsComponent,
          title: 'Tips',
          canClose: true,
          dialogMinWidth: '700px',
          componentData: {
            type: 'one-time-message',
          },
          onCloseButton: dialogRef => {
            dialogRef.close();
          },
          buttons: [
            {
              text: 'No',
              onClick: dialogRef => {
                this.dialogRef.close();
              },
              actAsClose: true,
              color: ButtonColor.RED,
              size: ButtonSize.NORMAL,
            },
            {
              text: 'Yes',
              onClick: dialogRef => {
                dialogRef.close();
              },
              actAsClose: true,
              color: ButtonColor.BLUE,
              size: ButtonSize.NORMAL,
            },
          ],
        },
      }),
    );
  }

  onWizardFinish($event: any) {
    const numberOfUsers = $event[ContactContactSelectionStepComponent.STEP_NAME].length;
    this.store$.dispatch(
      openSnackbar({
        snackbarData: {
          data: {
            message:
              'Onetime message was successfully send to ' + numberOfUsers + ' contacts!',
            type: 'success',
            button: {
              text: 'dismiss',
            },
          },
          verticalPosition: 'bottom',
        },
      }));
    this.dialogRef.closeDialog();
  }
}
